/* eslint semi:0 */
import { route } from 'mithril'
import { queryString } from '../../../utils/window'
import userStore from '../../stores/userStore'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import pageDataObject from '../../../application/pageDataObject'
import slideshowStore from '../../stores/slideshowStore'
import { noop, makeSafeFn } from '../../../utils/fn'
import utilsWindow from '../../../utils/window'
import { getIsAndroid, getIsIos } from '../../../utils/ua'

//NOTICE: this class should be (and is) used only for slideshow posts in native app
class CooladataNativeAppService extends AnalyticsBaseService {
  constructor(options = {}) {
    super(options)
    this.reportToNativeApp = noop
    if (this.isAndroidApp) {
      this.reportToNativeApp = this.reportToAndroidApp
    } else if (this.isIosApp) {
      this.reportToNativeApp = this.reportToIosApp
    }
  }

  get className() {
    return 'CooladataNativeAppService'
  }

  get isAndroidApp() {
    return getIsAndroid() && window.JSInterface && window.JSInterface.reportSlideshowView
  }

  get isIosApp() {
    return getIsIos() && utilsWindow.queryString.slideshow_count === '1'
  }

  routeChanged(action) {
    this.trackEvent('post_pageview', this.postPageViewArgs)
  }

  get postPageViewArgs() {
    let currentSlideNumber = slideshowStore.currentSlideIndex
    let templateData = pageDataObject.get('post.template_data') || {}
    return {
      /* eslint-disable camelcase */
      locale: pageDataObject.get('page.locale'),
      post_id: pageDataObject.get('post.id'),
      post_title: pageDataObject.get('post.title'),
      post_author_name: pageDataObject.get('post.author.name'),
      post_author_id: pageDataObject.get('post.author.id'),
      post_template: 'slideshow',
      current_slide: currentSlideNumber,
      current_slide_number: currentSlideNumber,
      current_slide_title: route.param('slideId'),
      items_order: templateData.items_order,
      media_type: pageDataObject.postMediaTypes[currentSlideNumber],
      media_provider: (templateData.media_provider || [])[currentSlideNumber],
      post_published_date: parseInt(pageDataObject.get('post.created_at') || 0, 10) * 1000,
      post_type: pageDataObject.get('post.type'),
      post_categories: (pageDataObject.get('post.categories') || []).join(','),
      /* eslint-enable */
    }
  }

  trackEvent(type, args) {
    this.logAnalytics(type, args)
    this.reportToNativeApp(JSON.stringify(args))
  }

  reportToAndroidApp(args) {
    makeSafeFn(() => window.JSInterface.reportSlideshowView(args))()
  }

  reportToIosApp(args) {
    window.location.href = `http://wwww.slideshowview.com?page_args=${args}`
  }
}

export default CooladataNativeAppService



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/cooladataNativeAppService.js